export const SOFTLINE_API_MACHINE_CATALOG_MACHINE_BY_ID =
  '/machine-sales-service/machine/{{machineId}}';
export const SOFTLINE_API_MACHINE_CATALOG_META_FORM =
  '/machine-sales-service/machine/metaForm';
export const SOFTLINE_API_MACHINE_CATALOG_META_CONTROL =
  '/machine-sales-service/machine/metaControl';

export const SOFTLINE_API_MACHINE_CATALOG_ADDITIONAL_FILTER =
  '/machine-sales-service/machine/query';

export const SOFTLINE_API_MACHINE_CATALOG_IMAGE =
  '/machine-sales-service/machine/{{machineId}}';
export const SOFTLINE_API_MACHINE_CATALOG_NOTES =
  '/machine-sales-service/machine/{{machineId}}/notes';
export const SOFTLINE_API_MACHINE_CATALOG_CREATE_NOTE =
  '/machine-sales-service/machine/{{machineId}}/note';
export const SOFTLINE_API_MACHINE_CATALOG_DATA_SHEET =
  '/machine-sales-service/machine/{{machineId}}/data-sheet';
